import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useMarketNow } from '../../features/marketConsole/queries';
import { STANCE_STYLES } from '../../lib/marketConsoleFormat';
import { cn } from '../../lib/utils';
import { Card } from '../ui/Card';

export function MarketStanceCard() {
  const now = useMarketNow();
  const stance = now.data?.stance;
  return (
    <Card
      className={cn('border-l-4', stance ? STANCE_STYLES[stance.key].border : 'border-l-border')}
      aria-label="Market stance"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-text-muted">
            Market stance{now.data?.planDate ? ` · plan for ${now.data.planDate}` : ''}
          </div>
          {now.isLoading ? (
            <p className="mt-1 text-sm text-text-muted">Loading market stance…</p>
          ) : now.isError || !stance ? (
            <p className="mt-1 text-sm text-text-muted">Market stance is unavailable.</p>
          ) : (
            <>
              <h2
                id="market-stance-heading"
                className={cn('mt-1 text-lg font-semibold', STANCE_STYLES[stance.key].text)}
              >
                {stance.label}
              </h2>
              <p className="mt-1 text-sm text-text-muted">{stance.guidance}</p>
            </>
          )}
        </div>
        <Link
          to="/market-console/now"
          className="inline-flex shrink-0 items-center gap-1 text-sm underline"
        >
          Open Market Console <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </Card>
  );
}
